import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@elkaso-app/web-design';
import { ICategoryTreeItem } from 'pages/supplier-intelligence/utils/types';
import { FiChevronRight } from 'react-icons/fi';

interface CategoryTreeSectionProps {
  categories: ICategoryTreeItem[];
  onCategoryClick?: (categories: ICategoryTreeItem[]) => void;
}

export const CategoryTreeSection = ({ categories, onCategoryClick }: CategoryTreeSectionProps) => (
  <Breadcrumb separator={<FiChevronRight color='gray' />}>
    {categories.map((cat, i) => {
      const isLast = i === categories.length - 1;
      const isClickable = !!onCategoryClick;

      return (
        <BreadcrumbItem key={cat.id} isCurrentPage={isLast}>
          <BreadcrumbLink
            fontSize='sm'
            fontWeight={isLast ? 'bold' : 'normal'}
            color={isClickable ? 'blue.500' : isLast ? 'blue.600' : 'gray.600'}
            cursor={isClickable ? 'pointer' : 'default'}
            _hover={{ textDecoration: isClickable ? 'underline' : 'none' }}
            onClick={isClickable ? () => onCategoryClick(categories.slice(0, i + 1)) : undefined}>
            {cat.name}
          </BreadcrumbLink>
        </BreadcrumbItem>
      );
    })}
  </Breadcrumb>
);
